export default "__VITE_ASSET__DaSdFVd8__"